import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { bindActionCreators } from "redux";
import { useMemo } from "react";
import { getAllSwitchableShops } from "app/reducers/shopSelector";
import ShopSwitcherDetailModal from "app/pages/Home/ShopSwitcher/ShopSwitcherDetailModal";
import { updateCurrency } from "app/reducers/currencyActionCreators";

const mapStateToProps = state => {
	return {
		currentShop: state?.shop,
		shops: getAllSwitchableShops(state),
		currentCurrency: state?.currency,
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{
			updateCurrency,
		},
		dispatch
	);
};

const ShopSwitcherDetailModalContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	const dispatch = useDispatch();
	const dispatchProps = useMemo(() => mapDispatchToProps(dispatch), [dispatch]);
	return <ShopSwitcherDetailModal {...props} {...stateProps} {...dispatchProps} />;
};

export default ShopSwitcherDetailModalContainer;
